import React from "react";

import { selectSelectedPartner, selectSelectedRange, selectSelectedStore } from "modules/customer/tools/product/productSlice";
import { useAppSelector } from "store";

const Subtitle: React.FC = () => {
    const selectedPartner = useAppSelector(selectSelectedPartner);
    const selectedRange = useAppSelector(selectSelectedRange);
    const selectedStore = useAppSelector(selectSelectedStore);
    return (
        <>
            Explore the positioning of the {selectedPartner?.name} {selectedStore?.name} store within its local area.
            Understand how factors like proximity to retail hubs, competitor density, and surrounding neighbourhoods impact {selectedRange?.name}'s potential in this location.
        </>
    );
};

export default Subtitle;
